import { render } from "./official-interact.vue?vue&type=template&id=779e0389&scoped=true"
import script from "./official-interact.vue?vue&type=script&lang=js"
export * from "./official-interact.vue?vue&type=script&lang=js"

import "./official-interact.vue?vue&type=style&index=0&id=779e0389&scoped=true&lang=css"

import exportComponent from "D:\\yiban\\WebProject\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-779e0389"]])

export default __exports__